import React from 'react';
import { useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import { ModeEditOutlineTwoTone } from "@mui/icons-material";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
    useLazyListVehicleNotesQuery,
    useUpdateVehicleNotesYMutation
} from "store/services/vehicleApi";

import FormDrawer from "components/Shared/FormDrawer";
import VehicleNotesForm from "./VehicleNotesForm";
import AppTable from "components/Shared/AppTable";

import { useTablePagination } from "hooks";

const VehicleNoteList = () => {
    const { id } = useParams();

    const [showNoteForm, setShowNoteForm] = React.useState(false);
    const [selectedNote, setSelectedNote] = React.useState(null);

    const { currentPage, handlePageChange, handlePerRowsChange } = useTablePagination({
        perPage: 5,
    });
    const [perPage, setPerPage] = React.useState(5);

    const columns = [
        {
            name: "Content",
            selector: (row) => row?.content,
            cell: (row) => row?.content,
        },
        {
            name: "Type",
            selector: (row) => row?.type,
            cell: (row) => row?.type,
        },
        {
            name: "Created By",
            selector: (row) => row?.createdBy?.name,
            cell: (row) => row?.createdBy?.name || "N/A",
        },
        {
            name: "Updated By",
            selector: (row) => row?.updatedBy?.name,
            cell: (row) => row?.updatedBy?.name || "N/A",
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <IconButton
                        size="small"
                        aria-label="Edit Note"
                        onClick={() => {
                            setSelectedNote(row);
                            setShowNoteForm(true);
                        }}
                    >
                        <ModeEditOutlineTwoTone />
                    </IconButton>
                </>
            ),
            ignoreRowClick: true,
            right: true,
        },

    ];

    // RTK Query
    const [updateNote, { isLoading: updatingNote }] =
        useUpdateVehicleNotesYMutation();

    const [fetchNotes, { data: notesRes, isLoading, isFetching }] =
        useLazyListVehicleNotesQuery();

    const handleUpdateNote = async (data) => {

        try {
            await updateNote({
                vehicleId: id,
                noteId: data?.noteId,
                ...data,
            }).unwrap();
            toast.success("Note updated successfully!");
            handleCancelNote();
        } catch (err) {
            toast.error(err?.data?.message ?? "Failed to update note!");
        }
        console.log(data, "test data ");
    };

    // methods
    const handleCancelNote = () => {
        setShowNoteForm(false);
        setSelectedNote(null);
    };

    const handleRowsPerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        handlePerRowsChange(newPerPage);
    };

    React.useEffect(() => {
        fetchNotes({
            vehicleId: id,
            page: currentPage,
            limit: perPage,
        });
    }, [currentPage, perPage, fetchNotes, id]);

    if (isLoading || isFetching) {
        return <p>Loading notes...</p>;
    }

    return (
        <>
            <BreadcrumbLayout.Paper>
                {notesRes ? (
                    <AppTable
                        columns={columns}
                        data={notesRes?.notes ?? []}
                        progressPending={isLoading || isFetching}
                        paginationServer
                        paginationPerPage={perPage}
                        paginationTotalRows={notesRes?.totalItems ?? 0}
                        paginationDefaultPage={currentPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handleRowsPerPageChange}
                    />
                ) : (
                    <p>Loading notes...</p>
                )}
            </BreadcrumbLayout.Paper>

            <FormDrawer
                title={selectedNote ? "Edit Note" : "Add Note"}
                open={showNoteForm}
                onClose={handleCancelNote}
            >
                <VehicleNotesForm
                    isBusy={updatingNote}
                    note={selectedNote}
                    onSubmit={handleUpdateNote}
                    onCancel={handleCancelNote}
                />
            </FormDrawer>

        </>

    );
};

export default VehicleNoteList;